var app;

app = window.App || (window.App = {});

app.InvoiceArticles = {
  add: function(e) {
    var articleAction, url;
    url = e.target.closest('form').dataset['group'];
    if (e.target.value) {
      articleAction = url + "/invoice_articles/" + e.target.value + ".json";
      $.ajax({
        url: articleAction,
        dataType: 'json',
        success: app.InvoiceArticles.updateForm
      });
    }
    return e.target.value = void 0;
  },
  updateForm: function(data, status, req) {
    var fields;
    document.querySelector('[data-action="nested-form#add"]').click();
    fields = $('#invoice_items_fields .fields').last().find('input, textarea');
    fields.each(function(idx, elm) {
      var name;
      name = elm.name.match(/\d\]\[(.*)\]$/)[1];
      if (data[name]) {
        return elm.value = data[name];
      }
    });
    return app.Invoices.recalculate();
  }
};

$(document).on('change', '#invoice_item_article', app.InvoiceArticles.add);
